
import { COMPANY_DATA_FAILED, COMPANY_DATA_LOADED, COMPANY_DATA_LOADING } from "../actions/returnType";
import { companyData } from "../constants/initalStateData";
export const companyReducer = (state = companyData, action) => {
    switch (action.type) {
        case COMPANY_DATA_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
                error: false,
            };
        case COMPANY_DATA_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                data: action.data,
            };
        case COMPANY_DATA_LOADED:
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                data: action.data,
            };
        default:
            return state;
    }
};